export default {
	state: {
		shops: [
			{
				id: '001',
				street: 'пр-кт Аксайский 23',
				point: 'АШАН'
			},
			{
				id: '002',
				street: 'пр-кт Аксайский 2',
				point: 'ЛЕНТА'
			},
			{
				id: '003',
				street: 'ул. Объездная, дом 14',
				point: 'МАГНИТ'
			}
		]
	},
	mutations: {},
	actions: {},

	getters: {
		getAksay (state) {
			return state.shops
		}
	}
}